<template>
  <b-form @submit.prevent="save" novalidate>
    <b-row>
       <b-col cols="12" md="4">
        <custom-input
          v-model="innerValue.label"
          :name="$gettext('label')"
          rules="required"
        />
      </b-col>
      <b-col cols="12" md="4">
        <b-form-group
          :label="$gettext('tag')"
          label-size="sm"
          size="sm"
          label-class="pt-1"
        >
          <custom-input
            groupType="input"
            v-model="innerValue.tag"
            :name="$gettext('tag')"
            size="sm"
            rules="required"
            v-uppercase
          >
            <template v-slot:prepend>
              <b-input-group-text size="sm" style="line-height: 0; background: #f9f9f9" class="p-1">
                ##
              </b-input-group-text>
            </template>
            <template v-slot:append>
              <b-input-group-text size="sm" style="line-height: 0; background: #f9f9f9" class="p-1">
                ##
              </b-input-group-text>
            </template>
          </custom-input>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4">
        <custom-input
          rules="required"
          v-model="innerValue.letter_type"
          :name="$gettext('letter type')"
          component="select"
          :options="letterTypes"
        />
      </b-col>
      <b-col cols="12">
        <custom-input
          v-model="innerValue.value"
          rules="required"
          :name="$gettext('template custom text')"
          component="textarea"
          :rows="10"
        />
      </b-col>
    </b-row>
    <b-btn type="submit" v-show="false" />
  </b-form>
</template>

<script>
import vModelMixin from '@/shared/mixins/v-model'

export default {
  mixins: [vModelMixin],
  props: {
    letterTypes: {
      type: Array,
      required: true,
    },
  },
  methods: {
    save() {
      this.$emit('save', this.innerValue)
    },
  },
}
</script>
